var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "personalizacao-paleta" },
    [
      _c(
        "div",
        { staticClass: "personalizacao-paleta__titulo ia-sidebar-aux" },
        [_vm._v(" " + _vm._s(_vm.texto.personalizacaoPaletaTitulo) + " ")]
      ),
      !_vm.itensLocais.length
        ? _c(
            "div",
            {
              staticClass: "personalizacao-paleta__vazio ia-sidebar-aux",
              attrs: { "data-test": "personalizacao-paleta-vazia" }
            },
            [_vm._v(" " + _vm._s(_vm.texto.personalizacaoPaletaVazia) + " ")]
          )
        : _c(
            "draggable",
            {
              staticClass: "personalizacao-paleta__lista",
              attrs: {
                list: _vm.itensLocais,
                group: { name: "painel-insights", pull: "clone", put: false },
                clone: _vm.clonarItem,
                sort: false,
                animation: 200,
                "ghost-class": "personalizacao-paleta__ghost"
              }
            },
            _vm._l(_vm.itensLocais, function(item) {
              return _c(
                "button",
                {
                  key: item.id,
                  staticClass: "personalizacao-paleta__addable",
                  attrs: {
                    type: "button",
                    "data-test": "personalizacao-paleta-item"
                  },
                  on: {
                    click: function($event) {
                      return _vm.adicionar(item)
                    }
                  }
                },
                [
                  _c("PersonalizacaoItemTile", {
                    attrs: {
                      id: item.id,
                      rotulo: item.rotulo,
                      icone: item.icone
                    }
                  })
                ],
                1
              )
            }),
            0
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }